import { useContext, useEffect, useRef, useMemo, useState } from "react";
import { graphqlOperation, API } from "aws-amplify";
import {
  companyByBusiness,
  companyByGroup,
  companyByOrganization,
  listCompanys,
} from "../graphql/client-queries";
import { useEffectAsync, listAll, captureError } from "../utilities";
import { AppContext } from "../contextProviders/AppContext";
import Cart from "../components/Cart";
import {
  Box,
  Collapse,
  Container,
  Grid,
  Typography,
  useTheme,
} from "@mui/material";
import Alert from "@mui/material/Alert";
import CloseIcon from "@mui/icons-material/Close";
import { LinearProgress, IconButton, Paper } from "@mui/material";
import AdditionalServices from "./MainPageContent/AdditionalServices";
import Results from "./MainPageContent/Results";
import Reservation from "./Reservation";
import React from "react";
import { Outlet } from "react-router-dom";
import { format, addMonths, isSameDay } from "date-fns";
import { fi } from "date-fns/locale";
import { getReservationsMonthly } from "../graphql/client-queries";
import ProductsSummary from "../components/ProductsSummary";
import InfoIcon from "@mui/icons-material/Info";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
export default function MainPage() {
  const theme = useTheme();
  const container = useRef();
  const {
    activeStep,
    enableCart,
    handleCompanies,
    closeCartAlert,
    isCartOpen,
    cartAlert,
    cartAlertProduct,
    mobileViewPort,
    selectedCompany,
    companies,
  } = useContext(AppContext);

  const cartIconPosition = useMemo(() => {
    const adjustPosition = window.URENT_APP_CART_POSITION;
    if (adjustPosition === "right") return "flex-end";
    if (adjustPosition === "left") return "flex-start";

    return "flex-end";
  }, [window.URENT_APP_CART_POSITION]);

  const showCartAlert = () => {
    if (isCartOpen) return;
    return (
      <Collapse in={cartAlert}>
        <Alert
          onClick={() => closeCartAlert(false)}
          style={{ cursor: "pointer" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography variant="body2">
              {cartAlertProduct} on lisätty ostoskoriin!
            </Typography>
            <CloseIcon style={{ marginLeft: 20 }} />
          </div>
        </Alert>
      </Collapse>
    );
  };

  // When adding product to the cart, alert is shown for 2 secs
  useEffectAsync(async () => {
    if (cartAlert) await timeout(2000);
    closeCartAlert();
  }, [cartAlert]);

  useEffectAsync(async () => {
    const allCompanies = await fetchCompanies();
    const filteredCompanies = allCompanies.filter((c) => !c.hidden);
    handleCompanies(filteredCompanies);
  }, []);

  useEffect(() => {
    // When user moves past the first view, scroll back to top of the app
    if (activeStep > 1) {
      container.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [activeStep]);

  // TODO merge: Verify that montlhy reservations is on some  other view
  //// Monthly Calendar components
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [infoOpen, setInfoOpen] = useState(false);
  const [calendarCompany, setCalendarCompany] = useState();
  const [calendarDate, setCalendarDate] = useState(new Date());
  const capitalize = (str) => {
    if (str) {
      return str[0].toUpperCase() + str.slice(1);
    } else {
      return str;
    }
  };
  const currentMonthString = capitalize(
    format(calendarDate, "LLLL", { locale: fi })
  );
  const changeMonth = (value) => {
    setCalendarDate(addMonths(calendarDate, value));
  };

  const fetchReservationsMonthly = async (date) => {
    const response = await API.graphql(
      graphqlOperation(getReservationsMonthly, {
        companyId: calendarCompany,
        dateInMonth: date.toJSON(),
      })
    );
    return response.data.getReservationsMonthly;
  };

  useEffectAsync(async () => {
    setLoading(true);
    if (calendarCompany) {
      try {
        const results = await fetchReservationsMonthly(calendarDate);

        setResults(results);
      } catch (e) {
        captureError("Get reservations montlhy failed", "GET_MONTHLY_FAIL", e);
      }

      setLoading(false);
    }
  }, [calendarDate, calendarCompany]);
  // Feature is controlled by company group
  const FEATURE_PRODUCTS_CALENDAR = useMemo(() => {
    if (selectedCompany) return selectedCompany?.enableMonthlyView;
  }, [selectedCompany]);

  // When companyId changes, its possible to hide the feature from spesific groups
  useEffect(() => {
    if (selectedCompany && FEATURE_PRODUCTS_CALENDAR) {
      return setCalendarCompany(selectedCompany.id);
    }
    return setCalendarCompany();
  }, [companies, FEATURE_PRODUCTS_CALENDAR, selectedCompany]);

  return (
    <>
      <Container
        maxWidth={mobileViewPort ? undefined : "lg"}
        disableGutters
        sx={{
          backgroundColor: theme.palette.primary.background,
          borderRadius: "14px",
          overflow: "hidden",
        }}
        ref={container}
      >
        {/*  From Outlet StepperComponent and ServiceProvider */}
        <Outlet />
        {activeStep === 2 && <Results />}
        {activeStep === 3 && <AdditionalServices />}
        {activeStep === 4 && <Reservation />}
        {FEATURE_PRODUCTS_CALENDAR && activeStep === 1 && (
          <Paper
            sx={{
              borderRadius: "14px",
              marginTop: "25px",
              overflow: "hidden",
            }}
          >
            <Grid item xs={11}>
              <Box>
                {!infoOpen && (
                  <div
                    style={{
                      position: "absolute",
                      right: 10,
                      bottom: 5,
                      color: "limegreen",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <IconButton
                      aria-label="close"
                      size="small"
                      onClick={() => {
                        setInfoOpen(true);
                      }}
                    >
                      <InfoIcon
                        fontSize="large"
                        style={{ color: "dodgerblue" }}
                      />
                    </IconButton>
                  </div>
                )}

                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",

                    height: 100,
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-evenly",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    <IconButton size="small" onClick={() => changeMonth(-1)}>
                      <ChevronLeftIcon
                        style={{ fontSize: 40, color: "black" }}
                      />
                    </IconButton>

                    <Typography variant="h4">{currentMonthString}</Typography>
                    <IconButton size="small" onClick={() => changeMonth(1)}>
                      <ChevronRightIcon
                        style={{ fontSize: 40, color: "black" }}
                      />
                    </IconButton>
                  </div>
                </div>
                <Collapse in={infoOpen}>
                  <Alert
                    style={{
                      display: "flex",
                      width: 600,
                      maxWidth: "80vw",
                    }}
                    severity="info"
                    action={
                      <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={() => {
                          setInfoOpen(false);
                        }}
                      >
                        <CloseIcon fontSize="inherit" />
                      </IconButton>
                    }
                    sx={{ mb: 2 }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: 35,
                          height: 20,
                          backgroundColor: "green",
                          borderRadius: 7,
                          marginRight: 10,
                        }}
                      ></div>
                      <Typography variant="body2"> = Vapaa</Typography>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                      }}
                    >
                      <div
                        style={{
                          width: 35,
                          height: 20,
                          backgroundColor: "darkred",
                          borderRadius: 7,
                          marginRight: 10,
                          marginTop: 5,
                        }}
                      ></div>
                      <Typography variant="body2"> = Varattu</Typography>
                    </div>
                  </Alert>
                </Collapse>
              </Box>
              {!loading && results.length > 0 && (
                <Box sx={{ overflow: "hidden", display: "flex" }}>
                  <ProductsSummary
                    results={results}
                    requestedStartTime={calendarDate}
                  />
                </Box>
              )}
              {loading && (
                <Box>
                  <LinearProgress
                    style={{
                      heigth: 150,
                      width: 150,
                      marginTop: 50,
                      marginBottom: 50,
                    }}
                  />
                </Box>
              )}
            </Grid>
          </Paper>
        )}
        <Grid
          container
          item
          justifyContent={cartIconPosition}
          xs={10}
          style={{
            position: "relative",
          }}
        >
          {!!activeStep && enableCart && <Cart />}
        </Grid>
      </Container>
      <div
        style={{
          display: "flex",
          position: "sticky",
          width: "100%",
          bottom: 10,
          justifyContent: "center",
        }}
      >
        {enableCart && showCartAlert()}
      </div>
    </>
  );
}

const FIXED_GROUPS = window.URENT_APP_GROUPS;
const FIXED_ORG_ID = window.URENT_APP_ORG_ID;
const FIXED_ORG_BUSINESS_ID = window.URENT_APP_ORG_BUSINESS_ID;
const FIXED_ORG_BUSINESS_IDS = window.URENT_APP_ORG_BUSINESS_IDS;

const listAllCompanies = async () => {
  const isLocalOrDev = ["local", "dev"].includes(process.env.REACT_APP_ENV);

  if (
    !isLocalOrDev &&
    !FIXED_GROUPS &&
    !FIXED_ORG_ID &&
    !FIXED_ORG_BUSINESS_ID &&
    !FIXED_ORG_BUSINESS_IDS
  ) {
    return [];
  }

  if (FIXED_GROUPS?.length > 0) {
    return await listAll(
      graphqlOperation(companyByGroup, {
        group: FIXED_GROUPS[0],
      }),
      "companyByGroup"
    );
  }

  if (FIXED_ORG_BUSINESS_ID) {
    return await listAll(
      graphqlOperation(companyByBusiness, {
        orgBusinessId: FIXED_ORG_BUSINESS_ID,
      }),
      "companyByBusiness"
    );
  }

  if (FIXED_ORG_BUSINESS_IDS) {
    const companyPromises = FIXED_ORG_BUSINESS_IDS.map((id) => {
      console.log("Fetching companies by business", id);
      return listAll(
        graphqlOperation(companyByBusiness, {
          orgBusinessId: id,
        }),
        "companyByBusiness"
      );
    });

    return Promise.allSettled(companyPromises).then((results) => {
      // Use flatMap to combine all fulfilled results into a single array of companies
      const companies = results.flatMap((result) =>
        result.status === "fulfilled" ? result.value : []
      );

      // Log errors
      results.forEach((result, index) => {
        if (result.status === "rejected") {
          console.error(
            `Failed to fetch company data for ID ${FIXED_ORG_BUSINESS_IDS[index]}:`,
            result.reason
          );
        }
      });

      // Return the concatenated array of successful company data
      return companies;
    });
  }

  if (FIXED_ORG_ID) {
    return await listAll(
      graphqlOperation(companyByOrganization, {
        organizationId: FIXED_ORG_ID,
        limit: 150,
      }),
      "companyByOrganization"
    );
  }

  return await listAll(
    graphqlOperation(
      listCompanys,
      FIXED_GROUPS
        ? {
            filter: {
              or: FIXED_GROUPS.map((group) => ({ group: { eq: group } })),
            },
          }
        : undefined
    ),
    "listCompanys"
  );
};

const fetchCompanies = async () => {
  let canRetry = true;
  try {
    let cache;
    if (!cache) {
      const companys = await listAllCompanies();
      cache = companys;
    }
    return cache;
  } catch (e) {
    if (canRetry) {
      // Wait for one second before retrying (in case it has an effect on network error
      // that sometimes occur during the initial load)
      await new Promise((resolve) => setTimeout(resolve, 1000));
      // Try fething one more time, in case error occurs on the initial fetch
      canRetry = false;
      return await listAllCompanies();
    } else {
      captureError("Fetching companies", "LIST_COMPANYS_FAILED", e);
    }
  }
};

function timeout(delay) {
  return new Promise((res) => setTimeout(res, delay));
}
